import first from 'lodash/first'
import isEmpty from 'lodash/isEmpty'
import { useState } from 'react'
import { jsonTryParse } from '@ztechapps/common.utils'
import { useQueryEffect } from '../useQueryEffect/index'
import { useTemplateList } from '../useTemplate/useTemplateList'
import type { ScaleOptions } from './useQzScale'

export type UseScaleTemplate = { scaleName: string; scaleOptions: ScaleOptions }

export const useScaleTemplate = (): UseScaleTemplate => {
  //TODO: Should consider the multi-tenancy, template request should be handled from the server itself
  //Even though we get the list, we will get only the first item from the list
  const templateList = useTemplateList({ filter: { category: 'scale_template' } })

  const [scaleName, setScaleName] = useState<string>()
  const [scaleOptions, setScaleOptions] = useState<ScaleOptions>()

  useQueryEffect(() => {
    //if there is no template, just get out
    if (isEmpty(templateList.list)) return

    //get the first item in the list
    const firstItem = first(templateList.list)
    const template = jsonTryParse(firstItem?.value) ?? {}

    setScaleName(template?.scaleName)

    //just needed options for the scale to work
    const scaleOptions: ScaleOptions = {
      vendorCode: template?.vendorCode,
      productCode: template?.productCode,
      byteLength: template?.byteLength ?? '6', //fairbanks scale uses 6 bytes
      scaleName: template?.scaleName,
      qzOption: template?.qzOption,
    }

    setScaleOptions(scaleOptions)
  }, templateList)

  return { scaleName, scaleOptions }
}
